// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"506":"673bfb7c","728":"4e9728b0"}[chunkId] + ".chunk.js";
};